import { api } from './api';

export const eventVisitorService = {
    addVisitorToEvent: async (data, sendEmail = true) => {
        const requestData = { ...data, sendEmail };
        const response = await api.post('/event-visitors', requestData);
        return response.data;
    },

    getEventVisitors: async (eventId) => {
        try {
            const response = await api.get(`/event-visitors/${eventId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching event visitors:', error);
            throw error;
        }
    },

    removeVisitorFromEvent: async (id) => {
        const response = await api.delete(`/event-visitors/${id}`);
        return response.data;
    },

    getVisitorHistory: async (visitorId) => {
        const response = await api.get(`/visitors/${visitorId}/history`);
        return response.data;
    }
}; 